// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // apiBaseUrl: 'http://localhost:1000/api',
  // apiBaseUrlUpload: 'http://localhost:1000/'
  
  apiBaseUrl: 'https://dreamsposbackend.quidak.com/api',
  apiBaseUrlUpload: 'https://dreamsposbackend.quidak.com/'

  // apiBaseUrl: 'https://back.quidak.com/api',
  // apiBaseUrlUpload: 'https://back.quidak.com/'

  // apiBaseUrl: 'https://back.bertinosoft.com/api',
  // apiBaseUrlUpload: 'https://back.bertinosoft.com/'

  // apiBaseUrl: 'https://back.anucamsoft.com/api',
  // apiBaseUrlUpload: 'https://back.anucamsoft.com/'

  // apiBaseUrl: 'https://back.nkapadistribution.com/api',
  // apiBaseUrlUpload: 'https://back.nkapadistribution.com/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
